import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var setLocale = function setLocale(locale) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var translations;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return context.api.l10n.setLocale({
              locale: locale
            });
          case 2:
            _context.next = 4;
            return context.api.l10n.getTranslations({
              locale: locale
            });
          case 4:
            translations = _context.sent;
            dispatch({
              type: "L10N/LOCALE_SET",
              payload: {
                locale: locale,
                translations: translations
              }
            });
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
};